import { Link } from 'react-router-dom';
import { IMAGE_ADDRESS } from '../../../../../apis';
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useCartHandlers } from '../../../../../utils/cartHandler';

const CardHeaderSHoppingCart = (props) => {

    const { product, selectedVariant, seller, slug, title, image, number, price } = props.data;

    const { handleAddToCart, handleMinusBtn } = useCartHandlers(selectedVariant, product, slug);

    const toPersianDigits = (num) => {
        return num.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);
    };

    return (

        <div className="br-list-vertical-0 mx-3 py-4" data-testid="cart-item">
            <div className="styles_CartItem__grid__rZXPE">
                <div className="flex flex-col items-center">
                    <Link className="relative" to={`/product/${slug}/${title.replace(/[\u200C]/g, '-').replace(/\s+/g, '-').replace(/-+/g, '-').replace(/[^\w\u0600-\u06FF-]+/g, '').replace(/^-+|-+$/g, '')}`}>
                        <div style={{width: '114px', height: '114px', lineHeight: '0'}}>
                            <picture>
                                <LazyLoadImage className="w-full inline-block" src={IMAGE_ADDRESS + image} width="114" height="114" alt={title} title="" style={{objectFit: 'contain'}} />
                            </picture>
                        </div>
                        <div className="bg-neutral-000 absolute bottom-0 left-0 rounded-small text-center text-neutral-900 text-caption-strong hidden styles_CartItem__imageQuantity__bzt41">۱
                        </div>
                    </Link>
                    <div className="mr-2">
                        <div className="flex items-center text-h5 py-2 mt-2 flex-col">
                            <div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="overflow-x-hidden">
                    <div className="">
                        <h3 className="text-neutral-800 text-body1-strong mb-2">{title}</h3>
                        { selectedVariant.attributeTile &&
                        <div className="flex">
                            <div className="flex mt-1">
                            { selectedVariant.optionColor === null ?
                                <svg style={{width: '18px', height: '18px', fill: 'var(--color-icon-low-emphasis)'}}>
                                    <use xlinkHref="#variationSize"></use>
                                </svg>
                                :
                                <svg style={{width: '18px', height: '18px', fill: `#${selectedVariant.optionColor}`}}>
                                    <use xlinkHref="#variationColor"></use>
                                </svg>
                            }
                            </div>
                            <p className="text-body-2 text-neutral-600 mr-2">
                                {selectedVariant.optionTitle}
                            </p>
                        </div>
                        }
                        <div className="flex flex-col w-full relative">
                            <ul className="flex flex-col">
                                <li className="flex ml-3 items-center">
                                    {/*<div className="flex">
                                        <svg style={{width: '14px', height: '14px', fill: 'var(--color-icon-high-emphasis)'}}>
                                            <use xlinkHref="#deliveryExpress"></use>
                                        </svg>
                                    </div>
                                    <p className="text-body-2 text-neutral-500 mr-2 ellipsis">ارسال  کوچی  از ۱ روز کاری دیگر
                                    </p>*/}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="flex flex-col items-center">
                    <div className="flex items-center justify-between user-select-none px-2 rounded-medium border-complete-200 item-quantity_ItemQuantity__box__5r4FJ">
                        <div onClick={() => handleAddToCart(seller)} className="flex cursor-pointer">
                            <svg data-testid="quantity-increase" data-cro-id="cart-add-quantity" style={{width: '18px', height: '18px', fill: 'var(--color-icon-primary)'}}>
                                <use xlinkHref="#addSimple"></use>
                            </svg>
                        </div>
                        <span className="flex flex-col items-center justify-between text-primary-500">
                            <span className="relative flex items-center justify-center text-h5">{toPersianDigits(number)}
                            </span>
                        </span>
                        <div onClick={() => handleMinusBtn(seller)} className="flex cursor-pointer">
                            <svg data-testid="quantity-decrease" data-cro-id="cart-delete-item-right" style={{width: '18px', height: '18px', fill: 'var(--color-icon-primary)'}}>
                                <use xlinkHref={`#${number > 1 ? 'removeSimple' : 'delete'}`}></use>
                            </svg>
                        </div>
                    </div>
                </div>
                <div>
                    <div className="flex items-center justify-between">
                        <div>
                            <div className="flex items-center justify-start ml-4">
                                <div className="flex justify-start items-center gap-1">
                                    <span className="text-h4 text-neutral-800">{toPersianDigits((price * number / 10).toLocaleString('fa'))}
                                    </span>
                                </div>
                                <div className="flex items-center justify-between">
                                    <div className="flex items-center">
                                        <div className="flex">
                                            <svg style={{width: '18px', height: '18px', fill: 'var(--color-icon-high-emphasis)'}}>
                                                <use xlinkHref="#toman"></use>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="flex a-center flex-row-reverse ml-4">
                        </div>
                    </div>
                </div>
            </div>
            <div className="mt-3 flex gap-2 flex-wrap">
            </div>
        </div>

    );
}

export default CardHeaderSHoppingCart;
